(() => {
  const promoSelector = '[data-pn-single-box-promo]';
  const promoPropertySelector = '[data-pn-eligible-single-box-property]';

  const getCurrentVariantId = (section) => {
    const input = section.querySelector('.product-variant-id, form[action*="/cart/add"] input[name="id"]');
    return input && input.value ? String(input.value) : '';
  };

  const setPromoVisibility = (promo, shouldShow) => {
    promo.hidden = !shouldShow;
    promo.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
  };

  const updatePromo = (promo, variantId) => {
    const eligibleVariantIds = (promo.dataset.eligibleVariantIds || '')
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean);
    setPromoVisibility(promo, eligibleVariantIds.includes(String(variantId)));
  };

  const updateEligibilityProperty = (section, variantId) => {
    if (!section) return;
    section.querySelectorAll(promoPropertySelector).forEach((input) => {
      const eligibleVariantIds = (input.dataset.eligibleVariantIds || '')
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean);
      input.disabled = !eligibleVariantIds.includes(String(variantId));
    });
  };

  const refreshPromos = (sectionId, variantId) => {
    document.querySelectorAll(promoSelector).forEach((promo) => {
      if (sectionId && promo.dataset.sectionId !== String(sectionId)) return;
      const section = promo.closest('.pn-product-page');
      const currentVariantId = variantId || (section ? getCurrentVariantId(section) : '');
      updatePromo(promo, currentVariantId);
      updateEligibilityProperty(section, currentVariantId);
    });
  };

  const refreshFromSelectedOptions = (event) => {
    const picker = event.target.closest('variant-selects, variant-radios');
    if (!picker) return;
    const section = picker.closest('.pn-product-page');
    if (!section) return;

    const selectedValues = Array.from(picker.querySelectorAll('fieldset input:checked, select option:checked'))
      .map((option) => String(option.value || '').trim().toLowerCase())
      .filter(Boolean);

    section.querySelectorAll(promoSelector).forEach((promo) => {
      const eligibleOptionValue = String(promo.dataset.eligibleOptionValue || '').trim().toLowerCase();
      if (!eligibleOptionValue) return;
      const shouldShow = selectedValues.includes(eligibleOptionValue);
      setPromoVisibility(promo, shouldShow);
      section.querySelectorAll(promoPropertySelector).forEach((input) => { input.disabled = !shouldShow; });
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    refreshPromos();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (!event || !event.data || !event.data.variant) return;
        refreshPromos(event.data.sectionId, event.data.variant.id);
      });
    }
  });

  document.addEventListener('change', refreshFromSelectedOptions);
  document.addEventListener('shopify:section:load', () => refreshPromos());
})();
